import { z } from "zod/v4"
import { StampCardId, UserId } from "../id"
import { DocumentSnapshotLike } from "../firestore"
import { UpdatedAt } from "./system"

export const UserStampCardStateSuperLaneUnlockByCoin = z.object({
  unlocked_at: z.date().describe("コインによるスーパーレーン解放の実行日時（JST）"),
  coins_charged: z.number().describe("スーパーレーン解放に消費したコイン枚数（コイン）"),
})

export type UserStampCardStateSuperLaneUnlockByCoin = z.infer<typeof UserStampCardStateSuperLaneUnlockByCoin>

export const UserStampCardStateDocumentMeta = z.object({
  user_id: z.string().describe("ユーザーID（コレクショングループクエリ対応のため。パスのIDはクエリ条件に使用できない制約がある）"),
  card_id: z.string().describe("対象スタンプカードのID"),
  stamp_count: z.number().describe("ユーザーの累計スタンプ数。ノーマル/スーパー共通で加算されます"),
  super_lane_unlock_by_coin: UserStampCardStateSuperLaneUnlockByCoin.optional().describe("コインによるスーパーレーン解放の情報。コインで解放した場合のみ存在します"),
  coins_spent_on_stamps: z.number().describe("不足スタンプ購入に消費した累計コイン枚数（コイン）。参考レート: 1スタンプ＝20コイン"),
})

export type UserStampCardStateDocumentMeta = z.infer<typeof UserStampCardStateDocumentMeta>

export const UserStampCardStateDocumentBody = z.intersection(
  UserStampCardStateDocumentMeta,
  z.object({
    last_updated: UpdatedAt,
  })
)

export type UserStampCardStateDocumentBody = z.infer<typeof UserStampCardStateDocumentBody>

export type UserStampCardStateDocument = UserStampCardStateDocumentBody & {
  id: StampCardId,
}

export class UserStampCardStateDocuments {

  static toDocumentData(doc: UserStampCardStateDocumentBody): object {
    return {
      ...doc,
    }
  }

  static fromDocumentSnapshot(doc: DocumentSnapshotLike | null): UserStampCardStateDocument | null {
    if (!doc) {
      return null
    }
    const data = doc.data()
    if (data === undefined) {
      return null
    }

    return {
      id: StampCardId(doc.id),
      user_id: UserId(data["user_id"]),
      card_id: data["card_id"],
      stamp_count: data["stamp_count"],
      super_lane_unlock_by_coin: data["super_lane_unlock_by_coin"],
      coins_spent_on_stamps: data["coins_spent_on_stamps"],
      last_updated: data["last_updated"],
    }
  }
}
